import { appApiSlice } from "src/api/app-ApiSlice";

export interface GetDeviceDesignsResponse {
    designs: string;
    sourceProductImage: string;
    project_id: string;
}

export enum DesignChangeScope {
    PRODUCT = 'product',
    ROOM = 'room',
    FLOOR = 'floor',
    PROJECT = 'project',
}

export interface SetDeviceDesignRequest {
    deviceId: number;
    selectedDesignId: number;
    type: DesignChangeScope;
    checkNotChangedProducts: boolean;
}

export interface ChangedProductWithImage {
    image: string;
    planObjectId: number;
}

export interface SetDeviceDesignResponse {
    success: boolean;
    notChangedProducts: string[];
    notChangedProductsTemplate: string;
    changedProductsIdsWithImages: ChangedProductWithImage[];
    floorId: number;
    color: string;
    manufacturer: string;
}

export const designApiSlice = appApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getDeviceDesigns: builder.query<GetDeviceDesignsResponse, number>({
            query: (deviceId) => ({
                url: `v1/project/get-design-by-device-id`,
                method: 'POST',
                body: { deviceId },
            }),
        }),
        setDeviceDesign: builder.mutation<SetDeviceDesignResponse, SetDeviceDesignRequest>({
            query: ({ checkNotChangedProducts, ...payload }) => ({
                url: `v1/project/set-device-design`,
                method: 'POST',
                body: { ...payload, checkNotChangedProducts: checkNotChangedProducts ? 'true' : 'false' },
            }),
        }),
    }),
    overrideExisting: false,
});

export const { useGetDeviceDesignsQuery, useSetDeviceDesignMutation } = designApiSlice;
